export const getWalletReducer = (
  state = {
    loading: false,
    wallet: {},
    withdrawLoading: false,
  },
  action
) => {
  switch (action.type) {
    case "GETTING_WALLET":
      return { ...state, loading: true };
    case "GETTING_WALLET_SUCCESS":
      return { ...state, loading: false, wallet: action.payload };
    case "GETTING_WALLET_ERROR":
      return { ...state, loading: false, wallet: null };
    case "REQUEST_WITHDRAWAL_LOADING":
      return { ...state, withdrawLoading: true };
    case "REQUEST_WITHDRAWAL_SUCCESS":
      return { ...state, withdrawLoading: false };
    case "REQUEST_WITHDRAWAL_FEILED":
      return { ...state, withdrawLoading: false };
    default:
      return state;
  }
};

export const recentTransactionReducer = (
  state = {
    loading: false,
    recentTransaction: [],
  },
  action
) => {
  switch (action.type) {
    case "GETTING_RECENT_TRANSACTION":
      return { ...state, loading: true };
    case "GETTING_RECENT_TRANSACTION_SUCCESS":
      return { ...state, loading: false, recentTransaction: action.payload };
    case "GETTING_RECENT_TRANSACTION_ERROR":
      return { ...state, loading: false, recentTransaction: [] };
    default:
      return state;
  }
};

export const withdrawalsReducer = (
  state = {
    loading: false,
    withdrawals: [],
  },
  action
) => {
  switch (action.type) {
    case "GETTING_WITHDRAWALS":
      return { ...state, loading: true, withdrawals: [] };
    case "GOT_WITHDRAWALS":
      return { ...state, loading: false, withdrawals: action.payload };
    case "CANNOT_GET_WITHDRAWALS":
      return { ...state, loading: false, withdrawals: [] };
    default:
      return state;
  }
};

export const emdTranscationReducer = (
  state = {
    loading: false,
    emdTranscationCollection: [],
  },
  action
) => {
  switch (action.type) {
    case "GETTING_EMD_TRANSACTION_HISTORY":
      return { ...state, loading: true, emdTranscationCollection: [] };
    case "GOT_EMD_TRANSACTION_HISTORY":
      return { ...state, loading: false, emdTranscationCollection: action.payload };
    case "CANNOT_GET_EMD_TRANSACTION_HISTORY":
      return { ...state, loading: false, emdTranscationCollection: [] };
    default:
      return state;
  }
};

export const refundsReducer = (
  state = {
    loading: false,
    refundsHistory: [],
  },
  action
) => {
  switch (action.type) {
    case "GETTING_REFUNDS":
      return { ...state, loading: true };
    case "GOT_REFUNDS":
      return { ...state, loading: false, refundsHistory: action.payload };
    case "CANNOT_GET_REFUNDS":
      return { ...state, loading: false, refundsHistory: [] };
    default:
      return state;
  }
};

export const AddBankReducer = (
  state = {
    loadings: false,
    AddBank: [],
  },
  action
) => {
  switch (action.type) {
    case "ADD_BANK_LOADING":
      return { ...state, loadings: true, AddBank: [] };
    case "ADD_BANK_DETAILS":
      return { ...state, loadings: false, AddBank: action.payload };
    case "ADD_BANK_LOADED":
      return { ...state, loadings: false, AddBank: [] };
    default:
      return state;
  }
};

export const AddMoneyToWalletReducer = (
  state = {
    loadings: false,
    bankDetail: {}
  },
  action
) => {
  switch (action.type) {
    case "SHOW_ADD_MONEY_LOADING":
      return { ...state, loadings: true,  };
    case "ADD_MONEY_TOBANK":
      return { ...state, loadings: false, bankDetail: action.payload };
    case "HODE_ADD_MONEY_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
};

